"use client"

import { MessagesSquare } from "lucide-react";

import ChatWidget from "@/components/powerchat/chatwidget";
import SidebarHeader from "@/components/sidebar-header";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { captureClientEvent } from "@/lib/telemetry-client";
import { cn } from "@/utils/utils";
import { useState } from "react";


export default function SidebarChatWidget({ className }: { className: string }) {
    const [open, setOpen] = useState(false);

    return (
        <Sheet
            open={open}
            onOpenChange={(isOpen) => {
                setOpen(isOpen);
                captureClientEvent(isOpen ? "chat_widget_opened" : "chat_widget_closed");
            }}
        >
            <SheetTrigger className={cn('bg-slate-950 border-amber-400 hover:scale-110  border-2 z-50 text-amber-400 hover:bg-slate-700 cursor-pointer p-4 rounded-full', className)}>
                <MessagesSquare />
            </SheetTrigger>

            <SheetContent
                side="left"
                className="flex flex-col overflow-hidden rounded-none border-none bg-slate-900 bg-none text-slate-50 px-2 pb-2 shadow-lg shadow-amber-400/30"
            >
                <SheetHeader className="hidden">
                    <SheetTitle>&nbsp;</SheetTitle>
                    <SheetDescription>&nbsp;</SheetDescription>
                </SheetHeader>
                <SidebarHeader title="Stellplatz-Chat" />
                <ChatWidget onInit={open} />
            </SheetContent>
        </Sheet>
    )
}